module.exports = __webpack_public_path__ + "static/media/jp.244bb6fd.svg";